import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth, db } from '../firebase';
import { getStorage, ref, listAll, getDownloadURL } from 'firebase/storage';
import Help_Video from '../components/Help_Video';
import {
  signInWithRedirect,
  getRedirectResult,
  GoogleAuthProvider,
  setPersistence,
  browserLocalPersistence,
  onAuthStateChanged,
} from 'firebase/auth';
import { 
  collection, 
  query, 
  getDocs, 
  orderBy, 
  limit,
  doc,
  updateDoc,
  increment,
  addDoc,
  where,
  startAfter
} from 'firebase/firestore';
import { 
  FilePlus, 
  Brain, 
  PenLine, 
  BookOpen, 
  Headset, 
  ChevronDown ,
  User
} from 'lucide-react';


function Login() {
  const navigate = useNavigate();
  const [showSplash, setShowSplash] = useState(true);
  const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  const pageSize = isMobile ? 10 : 20; // <--- ADD THIS
  
  // Data States
  const [allForms, setAllForms] = useState([]);
  const [filteredForms, setFilteredForms] = useState([]);
  const [loadingForms, setLoadingForms] = useState(true);

  const firestorePageSize = 200;
const [lastUploadsDoc, setLastUploadsDoc] = useState(null);
const [lastAiDoc, setLastAiDoc] = useState(null);
const [hasMoreForms, setHasMoreForms] = useState(true);
const [loadingMoreForms, setLoadingMoreForms] = useState(false);
  
  // UI States
  const [openId, setOpenId] = useState(null);
  const [visibleCount, setVisibleCount] = useState(pageSize); 
  const [isHeroExpanded, setIsHeroExpanded] = useState(false); 
  const [selectedType, setSelectedType] = useState('All Types');
  const [showRewardFlash, setShowRewardFlash] = useState(true); // ✅ Added Flash State

  const [citySchoolOptions, setCitySchoolOptions] = useState([]);

  useEffect(() => {
  const fetchCitySchools = async () => {
    try {
      const snapshot = await getDocs(collection(db, 'city_schools_prod'));

      const schools = snapshot.docs
        .map(docSnap => docSnap.data())
        .filter(item => item.city && item.school)
        .map(item => `${item.city}, ${item.school}`)
        .sort((a, b) => a.localeCompare(b));

      setCitySchoolOptions([...new Set(schools)]);
    } catch (error) {
      console.error('Error fetching city schools:', error);
    }
  };

  fetchCitySchools();
}, []);


  const getDeviceType = () => {
  const ua = navigator.userAgent;
  if (/iPad/i.test(ua)) return 'iPad';
  if (/iPhone/i.test(ua)) return 'iPhone';
  if (/Android/i.test(ua)) return 'Android';
  if (/Windows/i.test(ua)) return 'Windows Desktop';
  if (/Mac OS X/i.test(ua)) return 'Mac Desktop';
  if (/Linux/i.test(ua)) return 'Linux';
  return 'Other';
};


  // --- LANGUAGE DROPDOWN LOGIC ---
  const [browserLang, setBrowserLang] = useState(localStorage.getItem('appLang') || 'en');



  const handleLanguageChange = (e) => {
    const selectedLang = e.target.value;
    setBrowserLang(selectedLang); 
    localStorage.setItem('appLang', selectedLang); 

    setTimeout(() => {
      const googleSelect = document.querySelector('.goog-te-combo');
      if (googleSelect) {
        googleSelect.value = selectedLang;
        googleSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }, 10);
  };
  
  // --- LOCAL STORAGE FOR FILTERS ---
  const loadSavedFilters = () => {
    try {
      const saved = localStorage.getItem('eascode_public_filters');
      return saved ? JSON.parse(saved) : null;
    } catch (error) {
      console.error("Error parsing local storage", error);
      return null;
    }
  };

  const savedFilters = loadSavedFilters() || {};

  const [searchQuery, setSearchQuery] = useState(savedFilters.searchQuery || '');
  const [sortOption, setSortOption] = useState(savedFilters.sortOption || 'newest');
  const [selectedCitySchool, setSelectedCitySchool] = useState(savedFilters.selectedCitySchool || 'All Schools');
  const [selectedStandard, setSelectedStandard] = useState(savedFilters.selectedStandard || 'All_Standard');
  const [selectedSubject, setSelectedSubject] = useState(savedFilters.selectedSubject || 'All Subjects');

  // --- CREATOR SEARCH STATES ---
  const [allCreators, setAllCreators] = useState([]);
  const [filteredCreators, setFilteredCreators] = useState([]);
  const [showCreatorDropdown, setShowCreatorDropdown] = useState(false);

  useEffect(() => {
    const filtersToSave = {
      searchQuery,
      sortOption,
      selectedCitySchool,
      selectedStandard,
      selectedSubject
    };
    localStorage.setItem('eascode_public_filters', JSON.stringify(filtersToSave));
  }, [searchQuery, sortOption, selectedCitySchool, selectedStandard, selectedSubject]);

  useEffect(() => {
    const timer = setTimeout(() => setShowSplash(false), 2500);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const disableRightClick = (e) => {
      e.preventDefault();
    };
  
    document.addEventListener("contextmenu", disableRightClick);
  
    return () => {
      document.removeEventListener("contextmenu", disableRightClick);
    };
  }, []);

  {/* to be removed}
useEffect(() => {
    const fetchPublicForms = async () => {
      try {
        const uploadsRef = collection(db, 'uploads');
        const q = query(uploadsRef, orderBy('uploadTime', 'desc'), limit(40));
        const querySnapshot = await getDocs(q);

        // 1. Map regular uploads
        const formsData = querySnapshot.docs.map(docSnap => {
          const data = docSnap.data();
          const schoolName = data.school || 'General';
          const cityName = data.city || '';
          const citySchoolCombined = cityName ? `${cityName}, ${schoolName}` : schoolName;

          return {
            id: docSnap.id,
            title: data.calculatedFileName || data.fileName || 'Untitled',
            fileLink: data.fileUrl,
            uploadedBy: data.uploadedBy || 'Admin',
            creatorName: data.uploadername || 'Eascode Admin',
            downloads: data.downloads || 0,
            avgRating: data.avgRating || 0,
            numRatings: data.numRatings || 0,
            reportCount: data.reportCount || 0,
            // Standardize type here
            type: data.type || data.category || (data.fileType?.includes('pdf') ? 'PDF' : 'Image'), 
            standard: data.standard || 'N/A',
            subject: data.subject || 'Other',
            school: schoolName,
            city: cityName,
            citySchool: citySchoolCombined,
            lessonName: data.lessonName || 'Not Available',
            topics: Array.isArray(data.topicName?.current)
              ? data.topicName.current.join(", ")
              : String(data.topicName || "Not Available"),
            uploadTime: data.uploadTime?.toDate?.() || null,
            uid: data.uid,
          };
        });

        // 2. NEW ADDITION: Fetch AI_Results (Quizzes & Worksheets)
        try {
          // CORRECT: Grabs the newest 500 quizzes
          const quizzesQuery = query(collection(db, 'AI_Results'),limit (40));
          const quizzesSnapshot = await getDocs(quizzesQuery);
          
          quizzesSnapshot.forEach((docSnap) => {
            const data = docSnap.data();
            const schoolName = data.school || 'General';
            const cityName = data.city || '';
            const citySchoolCombined = cityName ? `${cityName}, ${schoolName}` : schoolName;

            // Handle AI Quizzes
            if (data.Quiz_Text && data.Quiz_Text !== 'No_Content') {
              formsData.push({
                id: docSnap.id,
                title: `${data.subject || 'Subject'} Quiz - ${data.topic || 'Topic'}`,
                fileLink: null, // Quizzes don't have file URLs
                uploadedBy: data.uploadername || "Eascode AI",
                creatorName: data.uploadername || "Eascode AI", 
                downloads: data.retake_count || 0,
                avgRating: 0,
                numRatings: 0,
                type: "AI_Quiz",
                standard: data.standard || "N/A",
                subject: data.subject || "Other",
                school: schoolName,
                city: cityName,
                citySchool: citySchoolCombined,
                lessonName: data.lesson || "Not Available",
                topics: data.topic || "Not Available",
                uploadTime: data.timestamp?.toDate?.() || null,
                uid: data.uid || 'ai_generated',
                Quiz_Text: data.Quiz_Text,
                totalQuestions: data.totalQuestions || 0,
              });
            }
            // Handle AI Worksheets (if you have them in this collection)
            else if (data.Worksheet_Text && data.Worksheet_Text !== 'No_Content') {
              formsData.push({
                id: docSnap.id,
                title: `${data.subject || 'Subject'} AI Worksheet - ${data.topic || 'Topic'}`,
                fileLink: null,
                uploadedBy: "Eascode AI",
                creatorName: "Eascode AI",
                downloads: data.downloads || 0,
                avgRating: 0,
                numRatings: 0,
                type: "AI_Worksheet",
                standard: data.standard || "N/A",
                subject: data.subject || "Other",
                school: schoolName,
                city: cityName,
                citySchool: citySchoolCombined,
                lessonName: data.lesson || "Not Available",
                topics: data.topic || "Not Available",
                uploadTime: data.timestamp?.toDate?.() || null,
                uid: data.uid || 'ai_generated',
                Worksheet_Text: data.Worksheet_Text,
              });
            }
          });
        } catch (err) {
          console.error("Error fetching AI Data:", err);
        }

        setAllForms(formsData);
        setFilteredForms(formsData);
      } catch (error) {
        console.error("Error fetching public forms:", error);
      } finally {
        setLoadingForms(false);
      }
    };

    fetchPublicForms();
  }, []);
*/}

const parseCitySchool = (value) => {
  if (!value || value === 'All Schools') return null;

  const [city, ...schoolParts] = value.split(',');
  const school = schoolParts.join(',').trim();

  if (!city?.trim() || !school) return null;

  return {
    city: city.trim(),
    school,
  };
};

const getUploadsOrderField = () => {
  if (sortOption === 'downloads') return 'downloads';
  if (sortOption === 'rating') return 'avgRating';
  return 'uploadTime';
};

const fetchPublicForms = async ({ append = false } = {}) => {
  if (append) {
    setLoadingMoreForms(true);
  } else {
    setLoadingForms(true);
    setHasMoreForms(true);
    setLastUploadsDoc(null);
    setLastAiDoc(null);
  }

  try {
    const formsData = [];
    const citySchool = parseCitySchool(selectedCitySchool);

    const shouldFetchUploads =
      selectedType === 'All Types' ||
      (selectedType !== 'AI_Quiz' && selectedType !== 'AI_Worksheet');

    const shouldFetchAi =
      selectedType === 'All Types' ||
      selectedType === 'AI_Quiz' ||
      selectedType === 'AI_Worksheet';

    let uploadsSnapshot = null;
    let aiSnapshot = null;

    if (shouldFetchUploads) {
      const uploadConstraints = [];

      if (selectedSubject !== 'All Subjects') {
        uploadConstraints.push(where('subject', '==', selectedSubject));
      }

      if (selectedStandard !== 'All_Standard') {
        uploadConstraints.push(where('standard', '==', String(selectedStandard)));
      }

      if (selectedType !== 'All Types') {
        uploadConstraints.push(where('type', '==', selectedType));
      }

      if (citySchool) {
        uploadConstraints.push(where('city', '==', citySchool.city));
        uploadConstraints.push(where('school', '==', citySchool.school));
      }

      uploadConstraints.push(orderBy(getUploadsOrderField(), 'desc'));

      if (append && lastUploadsDoc) {
        uploadConstraints.push(startAfter(lastUploadsDoc));
      }

      uploadConstraints.push(limit(firestorePageSize));

      uploadsSnapshot = await getDocs(query(collection(db, 'uploads'), ...uploadConstraints));

     uploadsSnapshot.docs.forEach((docSnap) => {
  const data = docSnap.data();
  const schoolName = data.school || 'General';
  const cityName = data.city || '';
  const citySchoolCombined = cityName ? `${cityName}, ${schoolName}` : schoolName;

  formsData.push({
    id: docSnap.id,
    title: data.calculatedFileName || data.fileName || 'Untitled',
    fileLink: data.fileUrl,
    uploadedBy: data.uploadedBy || 'Admin',
    creatorName: data.uploadername || 'Eascode Admin',
    downloads: data.downloads || 0,
    avgRating: data.avgRating || 0,
    numRatings: data.numRatings || 0,
    reportCount: data.reportCount || 0,
    type: data.type || data.category || (data.fileType?.includes('pdf') ? 'PDF' : 'Image'),
    standard: data.standard || 'N/A',
    subject: data.subject || 'Other',
    school: schoolName,
    city: cityName,
    citySchool: citySchoolCombined,
    lessonName: data.lessonName || 'Not Available',
    topics: Array.isArray(data.topicName?.current)
      ? data.topicName.current.join(", ")
      : String(data.topicName || "Not Available"),
    uploadTime: data.uploadTime?.toDate?.() || null,
    uid: data.uid,
  });
});
    }

    if (shouldFetchAi) {

      try{

      const aiConstraints = [];

      if (selectedSubject !== 'All Subjects') {
        aiConstraints.push(where('subject', '==', selectedSubject));
      }

      if (selectedStandard !== 'All_Standard') {
        aiConstraints.push(where('standard', '==', String(selectedStandard)));
      }

      if (citySchool) {
        aiConstraints.push(where('city', '==', citySchool.city));
        aiConstraints.push(where('school', '==', citySchool.school));
      }

      aiConstraints.push(orderBy('timestamp', 'desc'));

      if (append && lastAiDoc) {
        aiConstraints.push(startAfter(lastAiDoc));
      }

      aiConstraints.push(limit(firestorePageSize));

      aiSnapshot = await getDocs(query(collection(db, 'AI_Results'), ...aiConstraints));

aiSnapshot.forEach((docSnap) => {
  const data = docSnap.data();
  const schoolName = data.school || 'General';
  const cityName = data.city || '';
  const citySchoolCombined = cityName ? `${cityName}, ${schoolName}` : schoolName;

  if (data.Quiz_Text && data.Quiz_Text !== 'No_Content') {
    formsData.push({
      id: docSnap.id,
      title: `${data.subject || 'Subject'} Quiz - ${data.topic || 'Topic'}`,
      fileLink: null,
      uploadedBy: data.uploadername || "Eascode AI",
      creatorName: data.uploadername || "Eascode AI",
      downloads: data.retake_count || 0,
      avgRating: 0,
      numRatings: 0,
      type: "AI_Quiz",
      standard: data.standard || "N/A",
      subject: data.subject || "Other",
      school: schoolName,
      city: cityName,
      citySchool: citySchoolCombined,
      lessonName: data.lesson || "Not Available",
      topics: data.topic || "Not Available",
      uploadTime: data.timestamp?.toDate?.() || null,
      uid: data.uid || 'ai_generated',
      Quiz_Text: data.Quiz_Text,
      totalQuestions: data.totalQuestions || 0,
    });
  } else if (data.Worksheet_Text && data.Worksheet_Text !== 'No_Content') {
    formsData.push({
      id: docSnap.id,
      title: `${data.subject || 'Subject'} AI Worksheet - ${data.topic || 'Topic'}`,
      fileLink: null,
      uploadedBy: "Eascode AI",
      creatorName: "Eascode AI",
      downloads: data.downloads || 0,
      avgRating: 0,
      numRatings: 0,
      type: "AI_Worksheet",
      standard: data.standard || "N/A",
      subject: data.subject || "Other",
      school: schoolName,
      city: cityName,
      citySchool: citySchoolCombined,
      lessonName: data.lesson || "Not Available",
      topics: data.topic || "Not Available",
      uploadTime: data.timestamp?.toDate?.() || null,
      uid: data.uid || 'ai_generated',
      Worksheet_Text: data.Worksheet_Text,
    });
  }
});

    }
    catch (err) {
    console.error("Error fetching AI Data:", err);
  }
}

const newLastUploadsDoc = uploadsSnapshot?.docs.at(-1);
const newLastAiDoc = aiSnapshot?.docs.at(-1);

if (!append || newLastUploadsDoc) {
  setLastUploadsDoc(newLastUploadsDoc || null);
}

if (!append || newLastAiDoc) {
  setLastAiDoc(newLastAiDoc || null);
}

    setHasMoreForms(
      (uploadsSnapshot?.docs.length || 0) === firestorePageSize ||
      (aiSnapshot?.docs.length || 0) === firestorePageSize
    );

if (append) {
  setAllForms(prev => [...prev, ...formsData]);
  
    if (formsData.length > 0) {
    setVisibleCount(prev => prev + pageSize);
  }

} else {
  setAllForms(formsData);
  setFilteredForms(formsData);
  setVisibleCount(pageSize);
}
  } catch (error) {
    console.error("Error fetching public forms:", error);
  } finally {
    setLoadingForms(false);
    setLoadingMoreForms(false);
  }
};

useEffect(() => {
  fetchPublicForms({ append: false });
}, [selectedType, selectedSubject, selectedCitySchool, selectedStandard, sortOption]);

useEffect(() => {
  setVisibleCount(pageSize);
}, [searchQuery, pageSize]);

useEffect(() => {
    let filtered = allForms.filter(form => {
      // 1. Dropdown Filters
      const matchesSubject = selectedSubject === 'All Subjects' || form.subject === selectedSubject;
      const matchesType = selectedType === 'All Types' || form.type === selectedType;
      //alert(selectedType);
      //alert(form.type);
      //const matchesCitySchool = selectedCitySchool === 'All Schools' || selectedCitySchool.includes(form.citySchool);
      const matchesCitySchool = selectedCitySchool === 'All Schools' || form.citySchool === selectedCitySchool;

      //alert(selectedCitySchool);
      //alert(form.citySchool);
      
      let matchesStandard = true;
      if (selectedStandard !== 'All_Standard') {
        matchesStandard = String(form.standard) === String(selectedStandard);
      }

      // 2. Search Bar Filter
      const searchLower = (searchQuery || '').toLowerCase().trim();

      // If the search bar is empty, just show forms based on the dropdowns above
      if (!searchLower) {
        return matchesSubject && matchesType && matchesCitySchool && matchesStandard;
      }

      // 🔥 FRONTEND JOIN: Grab the real email from the public_profiles list
      const creatorData = allCreators.find(c => c.id === form.uid);
      const creatorEmail = creatorData ? (creatorData.email || '').toLowerCase() : '';

      // 3. Match against Form Data (Name OR Email OR Content)
      // The ( || '') prevents silent crashes if a form is missing a field in the database
      const matchesSearch = 
        (form.creatorName || '').toLowerCase().includes(searchLower) || // Searches Name
        (form.uploadedBy || '').toLowerCase().includes(searchLower) ||  
        creatorEmail.includes(searchLower) ||  // ✅ NOW SEARCHES THE REAL EMAIL!
        (form.title || '').toLowerCase().includes(searchLower) || 
        (form.lessonName || '').toLowerCase().includes(searchLower) || 
        (form.topics || '').toLowerCase().includes(searchLower);

      return matchesSubject && matchesType && matchesCitySchool && matchesStandard && matchesSearch;
    });

    // 4. Sort the filtered results
    filtered.sort((a, b) => {
      if (sortOption === 'newest') return (b.uploadTime?.getTime?.() || 0) - (a.uploadTime?.getTime?.() || 0);
      if (sortOption === 'rating') return (b.avgRating || 0) - (a.avgRating || 0);
      if (sortOption === 'downloads') return (b.downloads || 0) - (a.downloads || 0);
      return 0;
    });

    setFilteredForms(filtered);
    //setVisibleCount(pageSize); 
  }, [searchQuery, selectedType,selectedSubject, selectedCitySchool, selectedStandard, sortOption, allForms, pageSize,allCreators]);

  const uniqueSubjects = [...new Set(allForms.map(f => f.subject))].filter(Boolean).sort((a, b) => a.localeCompare(b));
  const subjects = ['All Subjects', ...uniqueSubjects];

  //const uniqueCitySchools = [...new Set(allForms.map(f => f.citySchool))].filter(s => s && s !== 'All Schools' && s !== 'General').sort((a, b) => a.localeCompare(b));
  

  const citySchoolsList = ['All Schools', ...citySchoolOptions];

  const schoolsWithForms = new Set(
  allForms
    .map(f => f.citySchool || (f.city && f.school ? `${f.city}, ${f.school}` : ''))
    .filter(Boolean)
);



  // 1. Fetch all public profiles once on load
  useEffect(() => {
    const fetchCreators = async () => {
      try {
        const snapshot = await getDocs(collection(db, 'public_profiles'));
        const creatorsData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setAllCreators(creatorsData);
      } catch (error) {
        console.error("Error fetching creators:", error);
      }
    };
    fetchCreators();
  }, []);

  // 2. Filter creators locally when the search query changes
  useEffect(() => {
    if (searchQuery.trim().length > 1) {
      const lowerQuery = searchQuery.toLowerCase();
const matched = allCreators.filter(c => 
        (c.displayName || '').toLowerCase().includes(lowerQuery) || 
        (c.school || '').toLowerCase().includes(lowerQuery) ||
        (c.email || '').toLowerCase().includes(lowerQuery) // ✅ Triggers dropdown on email
      );
      setFilteredCreators(matched.slice(0, 5)); // Only show top 5 results to keep the dropdown neat
    } else {
      setFilteredCreators([]);
    }
  }, [searchQuery, allCreators]);

  // Add this state at the top with your other states
const [carouselImages, setCarouselImages] = useState([]);

// Add this useEffect to fetch banners
useEffect(() => {
  const fetchBanners = async () => {
    try {
      const bannersRef = collection(db, "banners");
      // For Login page, we only show 'Online' banners since profile isn't loaded yet
      const q = query(bannersRef, where("city", "in", ["Online", selectedCitySchool || "Online"]));
      
      const querySnapshot = await getDocs(q);
      const bannerData = [];
      querySnapshot.forEach((doc) => {
        const data = doc.data();
        bannerData.push({
          image: data.imageUrl,
          link: data.targetUrl || "https://eascode.co.in"
        });
      });
      setCarouselImages(bannerData.sort(() => 0.5 - Math.random()));

      

    } catch (error) {
      
      console.error("Error fetching banners:", error);
    }
  };
  fetchBanners();
}, [selectedCitySchool]);


  // Auto-playing Carousel Component
const CityCarousel = ({ images, isMobile, city }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (!images || images.length === 0) return;
    
    // Change image every 2 seconds
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, 7000);
    
    return () => clearInterval(interval);
  }, [images]);

  if (!images || images.length === 0) return null;

 

  return (    

    <div className="w-full flex flex-col items-center bg-blue-50/50 py-3 md:py-6 px-1 rounded-xl md:rounded-2xl border border-blue-100 shadow-sm">
    
     {carouselImages.length > 0 && (
      <style>
        {`
          @keyframes marquee {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
          .animate-marquee-infinite {
            display: flex;
            width: max-content;
            animation: marquee 35s linear infinite;
          }
          .animate-marquee-infinite:hover {
            animation-play-state: paused;
          }
        `}
      </style>
    )}
{/* 
      {isMobile ? (
        // MOBILE: Single Image View
        <div className="w-full h-[180px] rounded-lg overflow-hidden relative shadow-md bg-white">
          <img 
            src={images[currentIndex]} 
            alt={`${city} Highlight`} 
            className="w-full h-full object-cover transition-opacity duration-500 ease-in-out"
            key={currentIndex} // Forces smooth React re-render animation
          />
        </div>
      ) : (
        // DESKTOP: Moving row of 3 images
        <div className="w-full h-[220px] flex gap-4 overflow-hidden">
          {[0, 1, 2].map(offset => {
             const index = (currentIndex + offset) % images.length;
             return (
               <div key={index} className="w-1/3 h-full rounded-xl overflow-hidden shadow-md bg-white shrink-0 transition-all duration-500 ease-in-out">
                 <img 
                   src={images[index]} 
                   alt={`${city} Highlight`} 
                   className="w-full h-full object-cover" 
                 />
               </div>
             )
          })}
        </div>
      )}
*/}
      
    </div> 
  ); 
};

const getOrCreateGuestId = () => {
    let guestId = localStorage.getItem('eascode_guest_id');
    if (!guestId) {
      guestId = 'guest_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
      localStorage.setItem('eascode_guest_id', guestId);
    }
    return guestId;
  };

  const handleDownload = async (form) => {
    // 1. Open the file instantly for the user
    const fileUrlToOpen = form.fileLink || form.fileUrl; 
    window.open(fileUrlToOpen, '_blank');

    try {
      // 2. Identify who is downloading
      const currentUser = auth.currentUser; 
      const downloaderId = currentUser ? currentUser.uid : getOrCreateGuestId();
      const downloaderRole = currentUser ? 'Registered User' : 'Public Guest';

      const currentDevice = getDeviceType();

      // 3. Log the event in your NEW Creator Analytics collection
      await addDoc(collection(db, 'creator_public_downloads'), {
        fileId: form.id,
        fileName: form.title,
        
        // This is the Uploader (Creator)
        creatorId: form.uid || 'Unknown', 
        creatorName: form.uploadedBy || 'Admin',

        // --- NEW: Immutable Snapshot of the file's location ---
        city: form.city || 'Unknown City',
        school: form.school || 'Unknown School',
        
        // This is the Downloader
        downloaderId: downloaderId,
        downloaderRole: downloaderRole,
        
        // Worksheet Meta
        subject: form.subject || 'N/A',
        standard: form.standard || 'N/A',
        type: form.type || 'N/A',
        device: currentDevice,
        timestamp: new Date()
      });

      // 4. Give the Creator their +1 on their Public Profile Storefront
      if (form.uid) {
        const creatorProfileRef = doc(db, 'public_profiles', form.uid);
        await updateDoc(creatorProfileRef, {
          totalDownloads: increment(1) 
        });
      }

      // 5. Give the Worksheet itself its +1 
      const worksheetRef = doc(db, 'uploads', form.id);
      await updateDoc(worksheetRef, {
        downloads: increment(1)
      });

      // 6. Update local React state for Login.js
      setFilteredForms(prev => prev.map(f => f.id === form.id ? { ...f, downloads: (f.downloads || 0) + 1 } : f));
      setAllForms(prev => prev.map(f => f.id === form.id ? { ...f, downloads: (f.downloads || 0) + 1 } : f));

    } catch (error) {
      console.error("Error logging public download:", error);
    }
  };

  {/*  signin with popup
  const handleGoogleLogin = async () => {
    try {
      const provider = new GoogleAuthProvider();
      provider.setCustomParameters({ prompt: 'select_account' });

      await setPersistence(auth, browserLocalPersistence);
      await signInWithPopup(auth, provider);
      handleNavigation('/Old_Home', { persona: 'parent' });
    } catch (error) {
      console.error('Login error:', error);
      const msg = error.message?.toLowerCase() || '';
      const code = error.code || '';

      if (code.includes('popup-blocked') || msg.includes('blocked')) {
        alert("Sign-in pop-up was blocked. Please allow pop-ups and try again.");
      } else {
        alert(error.message || 'An unexpected error occurred during login.');
      }
    }
  };

  */}

const handleGoogleLogin = () => {
  sessionStorage.removeItem('eascode_auth_redirect_started');
  sessionStorage.removeItem('eascode_auth_redirect_retry');
  sessionStorage.removeItem('eascode_post_login_redirect');
  navigate('/auth-loading');
};

  const handleNavigation = (path, state = {}) => {
    navigate(path, { state });
  };

const requireLoginClick = () => { alert("Please sign in to unlock this feature!"); };

 
  const currentVisibleForms = filteredForms.slice(0, visibleCount);
  //const currentVisibleForms = filteredForms;
  const formChunks = [];
  
  for (let i = 0; i < currentVisibleForms.length; i += pageSize) {
    formChunks.push(currentVisibleForms.slice(i, i + pageSize));
  }
  
  const currentCityName = selectedCitySchool.split(',')[0].trim();

  return (
    <div className="min-h-screen flex flex-col bg-gray-50 font-[Quicksand]">
      
      {showSplash ? (
        <main className="flex-1 flex justify-center items-center px-4 bg-white">
          <div className="flex flex-col items-center text-center animate-fadeIn">
            <button
              type="button"
              onClick={() => navigate('/EascodeChat')}
              className="mb-8 flex justify-center rounded-full focus:outline-none focus:ring-4 focus:ring-blue-200 group"
              aria-label="Open Eascode Chat"
              title="Open Eascode Chat"
            >
              <span className="w-60 h-60 md:w-72 md:h-72 rounded-full bg-white p-5 shadow-2xl border border-blue-100 flex items-center justify-center transition duration-300 group-hover:scale-105 group-hover:shadow-blue-100">
                <img src="./Eascode_No_Background.png" alt="Logo" className="w-full h-full object-contain rounded-full animate-float" />
              </span>
            </button>
            <h1 className="text-4xl md:text-5xl font-bold text-gray-800 tracking-tight">Eascode</h1>
            <p className="text-gray-500 mt-3 text-lg font-light">Empowering parents with every click</p>
          </div>
        </main>
      ) : (
        <>
          <header className="w-full py-3 px-3 md:py-4 md:px-8 flex justify-between items-center bg-white shadow-sm sticky top-0 z-50">
            <div className="flex items-center gap-2 md:gap-3">
              <button
                type="button"
                onClick={() => navigate('/EascodeChat')}
                className="w-11 h-11 md:w-14 md:h-14 rounded-full bg-white p-0.5 md:p-1 shadow-md border border-blue-100 flex items-center justify-center transition hover:scale-105 hover:shadow-blue-100 focus:outline-none focus:ring-2 focus:ring-blue-200"
                aria-label="Open Eascode Chat"
                title="Open Eascode Chat"
              >
                <img src="./Eascode_No_Background.png" alt="Logo" className="w-full h-full object-contain rounded-full" />
              </button>
              <div>
                <h1 className="text-lg md:text-xl font-bold text-gray-800 tracking-tight leading-none">Eascode</h1>
                <p className="text-[8px] md:text-[10px] text-gray-500 uppercase tracking-widest mt-0.5 md:mt-1">For Parents</p>
                <p className="text-[8px] md:text-[10px] text-gray-500 uppercase tracking-widest mt-0.5 md:mt-1">By Parents & Teachers</p>
              </div>
            </div>

            {/* 🌐 STACKED LANGUAGE SELECTOR */}
      <div className="flex flex-col items-start bg-white px-1 py-1 rounded-lg shadow-sm border border-gray-100 min-w-fit">
        
        {/* Label on top */}
        <span className="text-[9px] md:text-xs text-gray-400 font-bold uppercase tracking-wider leading-none mb-0.5">
          <span>Language</span>
        </span>

        {/* Dropdown below */}
        <select
          value={browserLang}
          onChange={handleLanguageChange}
          className="text-xs md:text-sm
                     bg-transparent text-gray-800
                     font-bold
                     border-none outline-none
                     cursor-pointer
                     hover:text-blue-600
                     transition-colors duration-200
                     notranslate
                     p-0 m-0"
          translate="no"
        >
          <option value="as" className="notranslate">Assamese</option>
          <option value="bn" className="notranslate">Bengali</option>
          <option value="en" className="notranslate">English</option>
          <option value="gu" className="notranslate">Gujarati</option>
          <option value="hi" className="notranslate">Hindi</option>
          <option value="kn" className="notranslate">Kannada</option>
          <option value="ml" className="notranslate">Malayalam</option>
          <option value="or" className="notranslate">Odia</option>
          <option value="pa" className="notranslate">Punjabi</option>
          <option value="ta" className="notranslate">Tamil</option>
          <option value="te" className="notranslate">Telugu</option>
          <option value="ur" className="notranslate">Urdu</option>
        </select>
      </div>

            <div className="flex gap-1.5 md:gap-4 items-center">
           {/*   <button
                onClick={() => handleNavigation('/SchoolLogin', { persona: 'Teacher_Admin' })}
                className="py-1.5 px-2 md:py-2 md:px-4 rounded-lg md:rounded-xl font-semibold bg-white border border-gray-300 text-gray-600 shadow-sm transition-all hover:-translate-y-0.5 hover:shadow-md text-[10px] md:text-sm whitespace-nowrap"
              >
                <span className="md:hidden">Teachers</span>
                <span className="hidden md:inline">Teacher/Admin Login</span>
              </button>
            */}
              <button
                onClick={handleGoogleLogin}
                className="py-1.5 px-3 md:py-2 md:px-6 rounded-lg md:rounded-xl font-semibold bg-blue-600 hover:bg-blue-700 text-white shadow-md transition-all duration-300 hover:-translate-y-0.5 hover:shadow-lg text-[10px] md:text-sm whitespace-nowrap"
              >
                <span className="md:hidden">Parents</span>
                <span className="hidden md:inline">Parents Login</span>
              </button>
            </div>
          </header>

                   {/* ✅ Eascode Premium FLASH POPUP */}
{showRewardFlash && (
  <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/40 backdrop-blur-sm px-2">
    
    <div className="relative w-full max-w-sm bg-white rounded-2xl shadow-2xl p-2 animate-[fadeIn_0.3s_ease-in-out]">

      <button
        onClick={() => {
          //sessionStorage.setItem("showPremiumCampaign", "false");
          setShowRewardFlash(false);
        }}
        className="absolute top-0 right-2 text-gray-700 hover:text-gray-700 text-xl font-bold z-10"
      >
        X
      </button>

      <img
        src="../Login_Eascode_Premium.png"
        alt="Eascode_Premium"
        className="w-full max-h-[50vh] object-contain rounded-xl hover:scale-[1.01] transition cursor-pointer"
        //onClick={() => {handleGoogleLogin();}}
      />

    </div>
  </div>
)}



          <main className="flex-1 w-full px-0 md:px-0 py-4 md:py-8 animate-fadeIn">
            
            <div className="text-center mb-4 md:mb-8">
              <h2 className="text-xl md:text-4xl font-bold text-gray-800 mb-2 px-2 leading-tight">
                Create, Share, and Download Custom Worksheets and Quiz
              </h2>
              

                      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'start' }}>
                        <Help_Video 
                          videoId="ExBJ6OBe3Ik" /* ⚠️ Replace with actual YouTube ID */
                          title="How to use Voice to Text" 
                        />
                      </div>

                <div className={`overflow-hidden transition-all duration-300 ${isHeroExpanded ? 'max-h-40 opacity-100 mt-2' : 'max-h-0 opacity-0'}`}>
                   <p className="text-x1 text-gray-600 md:text-x1 sm:text-x2 px-4 pb-2">
                    Join our community of parents and educators to access thousands of high-quality, AI-generated, and parent-approved educational resources.
                  </p>
                </div>
             


            </div>

            <div className="bg-white rounded-2xl shadow-sm p-3 md:p-4 mb-6 md:mb-8 border border-gray-100 max-w-7xl mx-auto">
              <div className="flex flex-wrap justify-center gap-2 sm:gap-4 lg:grid lg:grid-cols-5 lg:gap-2">
                {[
                  { text: "Create Worksheet", icon: FilePlus },
                  { text: "Solve Quiz", icon: Brain },
                  { text: "Composition", icon: PenLine },
                  //{ text: "Check Worksheet", icon: CheckCircle2 },
                  //{ text: "Discuss a Chapter", icon: Bot },
                  { text: "Comprehension", icon: BookOpen },
                  { text: "Request a Worksheet", icon: Headset }
                ].map((btn, idx) => {
                  const Icon = btn.icon;

                  
                  return (
                    <button
                      key={idx}
                      onClick={requireLoginClick}
                      className="w-auto lg:w-full flex items-center justify-center gap-1.5 md:gap-2 px-2.5 py-2 md:px-3 md:py-3 text-[11px] md:text-sm rounded-full bg-gray-50 text-gray-700 border border-gray-200 hover:bg-blue-50 hover:text-blue-600 hover:border-blue-200 hover:-translate-y-0.5 transition-all duration-200"
                    >
                      <Icon className="w-3.5 h-3.5 md:w-5 md:h-5" />
                      {btn.text}
                    </button>
                  );
                })}
              </div>
            </div>

            <div className="bg-white rounded-2xl shadow-sm p-3 md:p-6 border border-gray-100 mb-8 w-full">
              
              <div className="mb-4 md:mb-6 space-y-3 md:space-y-4">
                <div className="flex justify-between items-center px-1">
                  <h3 className="text-base md:text-xl font-bold text-gray-800">Search Worksheets,Quiz or Creators</h3>
                  <button 
                    onClick={() => {
                      setSearchQuery(''); setSortOption('newest'); setSelectedCitySchool('All Schools'); setSelectedStandard('All_Standard'); setSelectedSubject('All Subjects');setSelectedType('All Types');
                      localStorage.removeItem('eascode_public_filters');
                    }}
                    className="text-[10px] md:text-xs text-blue-600 hover:text-blue-800 font-semibold underline"
                  >
                    Clear Filters
                  </button>
                </div>

{/* Search Bar with Creator Auto-Complete */}
<div className="grid grid-cols-2 lg:grid-cols-2 gap-2 md:gap-3">
                <div className="flex flex-col">
                  <input
                    type="text"
                    placeholder="Search by Topic,Lesson,subject or creator names..."
                    value={searchQuery}
                    onChange={(e) => {
                      setSearchQuery(e.target.value);
                      setShowCreatorDropdown(true);
                    }}
                    onFocus={() => setShowCreatorDropdown(true)}
                    // Delay hiding the dropdown so the user has time to click a profile
                    onBlur={() => setTimeout(() => setShowCreatorDropdown(false), 200)} 
                    className="w-full px-3 md:px-4 py-2 md:py-3 border rounded-xl border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-400 text-xs md:text-sm"
                  />
                  
                  {/* The Floating Dropdown */}
                  {showCreatorDropdown && filteredCreators.length > 0 && (
                    <div className="absolute z-50 w-full mt-1 bg-white border border-gray-200 rounded-xl shadow-xl overflow-hidden animate-fadeIn">
                      <div className="px-3 py-2 bg-gray-50 border-b border-gray-100 text-[10px] uppercase tracking-wider font-bold text-gray-500">
                        Creators
                      </div>
                      {filteredCreators.map(creator => (
                        <div 
                          key={creator.id}
                          onClick={() => navigate(`/CreatorProfile/${creator.id}`)}
                          className="flex items-center gap-3 px-4 py-2 md:py-3 hover:bg-blue-50 cursor-pointer transition-colors border-b last:border-b-0 border-gray-50"
                        >
                          <div className="w-8 h-8 md:w-10 md:h-10 rounded-full bg-blue-100 flex items-center justify-center overflow-hidden border border-blue-200 shrink-0">
                            {creator.avatarUrl ? (
                              <img src={creator.avatarUrl} alt={creator.displayName} className="w-full h-full object-cover" />
                            ) : (
                              <User className="w-4 h-4 md:w-5 md:h-5 text-blue-500" />
                            )}
                          </div>
                          <div className="flex-1 min-w-0">
                            <p className="text-xs md:text-sm font-bold text-gray-800 truncate">{creator.displayName}</p>
                            <p className="text-[10px] md:text-xs text-gray-500 truncate">
                              {[creator.city, creator.school]
                                .filter(Boolean)
                                .join(' • ')}
                            </p>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}

                  </div>

                  
                  <div className="flex flex-col">
                    
                    <select value={sortOption} onChange={(e) => setSortOption(e.target.value)} className="w-full px-3 md:px-4 py-2 md:py-3 border rounded-xl border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-400 text-xs md:text-sm">
                      <option value="newest">Newest</option>
                      <option value="rating">Highest Rated ⭐</option>
                      <option value="downloads">Most Downloads 📥</option>
                    </select>
                  </div>

                  

                  </div>

                
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-2 md:gap-3">

                              <div className="flex flex-col">
                    <label className="text-[9px] md:text-xs font-semibold text-gray-600 mb-0.5 md:mb-1">Subject</label>
                    <select value={selectedSubject} onChange={(e) => setSelectedSubject(e.target.value)} className="w-full px-2 md:px-3 py-1.5 md:py-2 border rounded-lg border-gray-300 text-[10px] md:text-sm focus:outline-none focus:ring-2 focus:ring-blue-400">
                      {subjects.map(sub => <option key={sub} value={sub}>{sub}</option>)}
                    </select>
                  </div>

            <div className="flex flex-col">
              <label className="text-[10px] md:text-xs font-semibold text-gray-600 mb-0.5 md:mb-1">Type</label>
              <select
                value={selectedType}
                onChange={(e) => setSelectedType(e.target.value)}
                className="w-full px-2 md:px-3 py-1.5 md:py-2 border rounded-md md:rounded-lg border-gray-300 text-[10px] md:text-sm focus:outline-none focus:ring-2 focus:ring-blue-400 truncate bg-white"
              >
                <option value="All Types">All Types</option>
                <option value="AI_Worksheet">AI Worksheets</option>
                <option value="Worksheet">Parent Worksheets</option>
                <option value="Assessment">School Assessment</option>
                <option value="AI_Quiz">AI Quiz</option>
              </select>
            </div>

                              <div className="flex flex-col">
                    <label className="text-[9px] md:text-xs font-semibold text-gray-600 mb-0.5 md:mb-1">Standard</label>
                    <select value={selectedStandard} onChange={(e) => setSelectedStandard(e.target.value)} className="w-full px-2 md:px-3 py-1.5 md:py-2 border rounded-lg border-gray-300 text-[10px] md:text-sm focus:outline-none focus:ring-2 focus:ring-blue-400">
                      <option value="All_Standard">All Standard</option>
                      {[...Array(12).keys()].map(i => <option key={i+1} value={(i+1).toString()}>Standard {i+1}</option>)}
                    </select>
                  </div>



                  <div className="flex flex-col">
                    <label className="text-[9px] md:text-xs font-semibold text-gray-600 mb-0.5 md:mb-1">City, School</label>
                    <select value={selectedCitySchool} onChange={(e) => setSelectedCitySchool(e.target.value)} className="w-full px-2 md:px-3 py-1.5 md:py-2 border rounded-lg border-gray-300 text-[10px] md:text-sm focus:outline-none focus:ring-2 focus:ring-blue-400">
                      {citySchoolsList.map(cs => {
  const hasForms = cs !== 'All Schools' && schoolsWithForms.has(cs);

  return (
    <option
      key={cs}
      value={cs}
      style={hasForms ? {
        backgroundColor: '#dcfce7',
        color: '#166534',
        fontWeight: 600
      } : {}}
    >
      {hasForms ? `✓ ${cs}` : cs}
    </option>
  );
})}

                    </select>
                  </div>





                  </div>
                </div>
              </div>

              

              <div className="bg-white rounded-2xl shadow-sm p-3 md:p-6 border border-gray-100 mb-8 w-full">

              {loadingForms ? (
                  <div
                    role="status"
                    aria-live="polite"
                    className="flex flex-col justify-center items-center h-48 gap-3"
                  >
                    <div className="h-8 w-8 rounded-full border-4 border-blue-100 border-t-blue-600 animate-spin" />
                    <p className="text-gray-500 text-xs md:text-sm font-medium">
                      Loading learning resources...
                    </p>
                  </div>
              ) : filteredForms.length === 0 ? (
                <div className="flex justify-center items-center h-48 text-center px-4">
                  <p className="text-gray-500 text-xs md:text-sm font-medium">No resources found for your search criteria.</p>
                </div>
              ) : (
                <div className="w-full flex flex-col">
                  {/* MAP OVER CHUNKS INSTEAD OF ALL FORMS */}
                  {formChunks.map((chunk, chunkIndex) => (
                    <React.Fragment key={`chunk-${chunkIndex}`}>
                      
                      {/* INJECT CAROUSEL OR A SPACER BEFORE NEW CHUNKS */}
                      {chunkIndex > 0 && (
                        carouselImages.length > 0 ? (
                          <div className="w-full my-6 md:my-10 px-4 md:px-0">
                            <CityCarousel images={carouselImages} isMobile={isMobile} city={currentCityName} />
                          </div>
                        ) : (
                          /* Fallback spacer when no city/carousel is active */
                          <div className="w-full h-4 md:h-8"></div>
                        )
                      )}

                      {/* YOUR EXACT GRID STARTING HERE */}
                      <div className="grid grid-cols-2 lg:grid-cols-4 gap-2 md:gap-4 w-full">
                      {chunk.map(form => (
                          <div key={form.id} className={`rounded-xl md:rounded-2xl shadow-md hover:shadow-xl transition overflow-hidden border flex flex-col ${form.type === 'AI_Quiz' ? 'col-span-1 lg:col-span-1' : 'col-span-2 lg:col-span-1'} ${form.reportCount > 0 ? 'bg-red-50 border-red-300' : 'bg-white border-gray-400'}`}>                        {/* File Name */}
                        <h3 className="px-3 pt-2 font-semibold text-gray-800 text-sm line-clamp-2 leading-snug break-all" title={form.title}>
                          {form.title}
                        </h3>

                {/* File Preview */}
                    <div
                      className="bg-gray-100 flex items-center justify-center h-[400px] lg:h-[450px] relative overflow-hidden"
                      onContextMenu={(e) => e.preventDefault()}
                    >

                       {form.type === 'AI_Quiz' ? (
                        <div className="w-full h-full bg-slate-50 p-4 overflow-y-auto relative text-left">
                          {/* Sticky Header */}
                          <div className="sticky top-0 bg-slate-50/95 backdrop-blur-sm pb-2 mb-3 border-b border-slate-200 z-10 flex justify-between items-end">
                            <span className="font-bold text-indigo-700 text-sm">Quiz Preview</span>
                            <span className="text-[10px] font-bold bg-indigo-100 text-indigo-800 px-2 py-1 rounded-md">
                              {form.totalQuestions} Questions
                            </span>
                          </div>

                          {/* Questions List */}
                          <div className="space-y-3 pb-4">
                            {form.Quiz_Text && form.Quiz_Text !== 'No_Content' ? (
                              form.Quiz_Text.split('\n\n').map((block, idx) => {
                                const lines = block.split('\n');
                                const qLine = lines.find(l => l.toLowerCase().startsWith('question:'));
                                const optionsLine = lines.find(l => l.toLowerCase().startsWith('options:'));

                                if (!qLine) return null;

                                return (
                                  <div key={idx} className="bg-white p-3 rounded-xl shadow-sm border border-slate-200">
                                    <p className="font-bold text-slate-800 text-[11px] leading-snug">
                                      <span className="text-indigo-500 mr-1">{idx + 1}.</span> 
                                      {qLine.replace(/question:/i, '').trim()}
                                    </p>
                                    
                                    {optionsLine && (
                                      <div className="mt-2 space-y-1">
                                        {optionsLine.replace(/options:/i, '').split('|').map((opt, i) => (
                                          <div key={i} className="text-[10px] text-slate-600 bg-slate-50 px-2 py-1.5 rounded-md border border-slate-100">
                                            {String.fromCharCode(65 + i)}. {opt.trim()}
                                          </div>
                                        ))}
                                      </div>
                                    )}
                                  </div>
                                );
                              })
                            ) : (
                              <div className="text-xs text-slate-500 text-center mt-10">No questions available to preview.</div>
                            )}
                          </div>
                          
                          {/* Fade out effect at the bottom for aesthetics */}
                          <div className="sticky bottom-0 left-0 right-0 h-8 bg-gradient-to-t from-slate-50 to-transparent pointer-events-none"></div>
                        </div>
                      ) : form.fileLink?.toLowerCase().includes(".pdf") ? (
                        isMobile ? (
                          <iframe
                            src={`https://docs.google.com/gview?url=${encodeURIComponent(form.fileLink)}&embedded=true`}
                            title="preview"
                            className="w-full h-full"
                          />
                        ) : (
                          <iframe
                            src={`${form.fileLink}#toolbar=0&navpanes=0&scrollbar=1`}
                            title="preview"                            
                            className="w-full h-full"
                          />
                        )
                      ) : (
                        <img
                          src={form.fileLink}
                          alt="preview"                          
                          className="object-cover w-full h-full"
                        />
                      )}

                      </div>



                            <div className="flex-1 flex flex-col justify-between">

                              <div className="mt-1 border-t border-gray-100">
                                <button
                                  onClick={() => setOpenId(openId === form.id ? null : form.id)}
                                  className="w-full flex items-center justify-between px-2 md:px-3 py-1.5 md:py-2 text-[10px] md:text-sm font-medium text-gray-700 hover:bg-gray-50"
                                >
                                  <span>Details</span>
                                  <ChevronDown className={`w-3 h-3 md:w-4 md:h-4 transition-transform duration-300 ${openId === form.id ? "rotate-180" : ""}`} />
                                </button>

                                <div className={`overflow-hidden transition-all duration-300 ${openId === form.id ? "max-h-96 opacity-100" : "max-h-0 opacity-0"}`}>
                                  <div className="px-2 md:px-3 pb-2 pt-1 text-[9px] md:text-xs text-gray-600 space-y-1">
                                    {/* ✅ Shows ONLY the Creator Name */}
                                    <p className="font-bold text-blue-600">Creator: {form.creatorName}</p>
                                    
                                    <p className="mt-1">Lesson: {form.lessonName}</p>
                                    <p>Type: {form.type}</p>
                                    <p>City, School: {form.citySchool}</p>
                                    <p>Standard: {form.standard}</p>
                                    <p>Topics: {form.topics}</p>
                                    {form.uploadTime && <p>Uploaded on: {form.uploadTime.toLocaleDateString()}</p>}
                                  </div>
                                </div>
                              </div>

                              <div className="px-2 md:px-3 pb-1.5 pt-1 text-[9px] md:text-sm border-t border-gray-100">
                                <div className="flex items-center justify-between mb-0.5">
                                  <span className="text-gray-600 font-semibold">Rating:</span>
                                  <span className="font-bold text-gray-800">
                                    {form.avgRating?.toFixed(1) || '0.0'} ⭐
                                  </span>
                                </div>
                                <div className="flex items-center gap-0.5 md:gap-1">
                                  {[1,2,3,4,5].map(star => (
                                    <span
                                      key={star}
                                      onClick={requireLoginClick}
                                      className="cursor-pointer text-gray-300 hover:text-yellow-400 text-xs md:text-base"
                                    >
                                      ★
                                    </span>
                                  ))}
                                </div>
                              </div>

                              {/* Buttons also have slight horizontal padding for better tap-targets */}

                              { (form.type.includes('Worksheet') || form.type.includes('Assessment') || form.type.includes('Image')) && (
<div className="px-1.5 md:px-3 pb-2.5 flex flex-wrap gap-1 md:gap-2 mt-1">
                                {form.reportCount > 0 ? (
                                  <button
                                    disabled
                                    className="flex-1 bg-red-200 text-red-800 py-1.5 md:py-2 px-1 rounded-full text-[9px] md:text-xs font-bold cursor-not-allowed opacity-80"
                                  >
                                    Under Review
                                  </button>
                                ) : form.type.includes('Quiz') ? (
                                  <button
                                    onClick={requireLoginClick}
                                    className="flex-1 bg-blue-50 hover:bg-blue-600 hover:text-white text-blue-700 border border-blue-200 py-1.5 md:py-2 px-1 rounded-full text-[9px] md:text-xs font-bold transition-all"
                                  >
                                    Take Quiz 
                                  </button>
                                ) : (
                                  <>
                                    <button
                                      onClick={() => handleDownload(form)}
                                      className="flex-1 bg-blue-50 hover:bg-blue-600 hover:text-white text-blue-700 border border-blue-200 py-1.5 md:py-2 px-1 rounded-full text-[9px] md:text-xs font-bold transition-all"
                                    >
                                      Download ({form.downloads})
                                    </button>
                                    <button
                                      onClick={requireLoginClick}
                                      className="flex-1 bg-gray-50 hover:bg-gray-200 text-gray-800 border border-gray-200 py-1.5 md:py-2 px-1 rounded-full text-[9px] md:text-xs font-medium transition"
                                    >
                                      Share
                                    </button>
                                  </>
                                )}
                              </div>
                              )}

                            { form.type.includes('Quiz') && (
                              <div className="px-1.5 md:px-3 pb-2.5 flex flex-wrap gap-1 md:gap-2 mt-1">
                                <button
                                  onClick={requireLoginClick}
                                  className="flex-1 bg-blue-50 hover:bg-blue-600 hover:text-white text-blue-700 border border-blue-200 py-1.5 md:py-2 px-1 rounded-full text-[9px] md:text-xs font-bold transition-all"
                                >
                                  Take Quiz 
                                </button>
                              </div>
                              )}


                            </div>
                          </div>
                        ))}
                      </div>
                    </React.Fragment>
                  ))}
                </div>
              )}

             
{!loadingForms && filteredForms.length > 0 && (
  <div className="mt-6 md:mt-8 flex justify-center">
    {visibleCount < filteredForms.length || hasMoreForms ? (
      <button
        onClick={async () => {
          if (visibleCount < filteredForms.length) {
            setVisibleCount(prev => prev + pageSize);
          } else if (hasMoreForms) {
            await fetchPublicForms({ append: true });
          }
        }}
        disabled={loadingMoreForms}
        className="bg-white border-2 border-blue-600 text-blue-600 hover:bg-blue-600 hover:text-white px-6 md:px-8 py-2 md:py-3 rounded-full font-bold text-xs md:text-sm shadow-sm transition-all duration-300"
      >
        {loadingMoreForms ? 'Loading...' : 'Show me more'}
      </button>
    ) : (
      <p className="text-xs md:text-sm text-gray-400 font-medium">
        No more forms
      </p>
    )}
  </div>
)}

              {/* 2. The Rotating Carousel (Appears after every 5/8 items) */}
             {carouselImages.length > 0 && (
      <style>
        {`
          @keyframes marquee {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
          .animate-marquee-infinite {
            display: flex;
            width: max-content;
            animation: marquee 35s linear infinite;
          }
          .animate-marquee-infinite:hover {
            animation-play-state: paused;
          }
        `}
      </style>
    )}
        <div className="w-full overflow-hidden rounded-2xl bg-gray-50 border border-gray-100 relative shadow-inner my-6">
          <div className="relative h-[300px] md:h-[300px] lg:h-[400px] flex items-center">
            <div className="animate-marquee-infinite flex gap-4 p-2 h-full">
              {[...carouselImages, ...carouselImages].map((banner, index) => (
                <a 
                  key={`login-banner-${index}`}
                  href={banner.link}
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="w-[45vw] md:w-[31vw] lg:w-[61vw] h-full flex-shrink-0 block"
                >
                  <img 
                    src={banner.image} 
                    alt="Banner" 
                    className="w-full h-full object-cover rounded-xl shadow-sm border border-white hover:scale-[1.01] transition-transform duration-300" 
                  />
                </a>
              ))}
            </div>
          </div>
        </div>
      



            </div>
          </main>

          <footer className="text-center py-6 md:py-8 bg-white border-t border-gray-200 text-gray-500">
            <div className="flex justify-center flex-wrap gap-4 md:gap-6 mb-4 text-[10px] md:text-sm px-4">
              <a href="https://eascode.co.in/about-us" target="_blank" rel="noopener noreferrer" className="hover:text-gray-800 transition">About Us</a>
              <a href="https://eascode.co.in/contact-us" target="_blank" rel="noopener noreferrer" className="hover:text-gray-800 transition">Contact Us</a>
              <a href="https://eascode.co.in/privacy-policy" target="_blank" rel="noopener noreferrer" className="hover:text-gray-800 transition">Privacy Policy</a>
              <a href="https://eascode.co.in/terms-of-service" target="_blank" rel="noopener noreferrer" className="hover:text-gray-800 transition">Terms of Service</a>
              <span onClick={() => handleNavigation('/Tutorials', { state: { persona: 'Viewer' } })} className="hover:text-gray-800 cursor-pointer transition">Tutorial Videos</span>
            </div>
            <p className="text-[10px] md:text-sm text-gray-400">© 2026 Eascode All Rights Reserved.</p>
          </footer>
        </>
      )}
    </div>
  );
}

export default Login;
